// extracted by mini-css-extract-plugin
module.exports = {"PaginationBullet":"bullet-pagination_PaginationBullet__cYBkn","PaginationBulletActive":"bullet-pagination_PaginationBulletActive__E8yaZ"};